import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { ICompany } from 'src/app/pages/companies/models/company.interface';
import { CompanyService } from 'src/app/pages/companies/services/company.service';
import { EMessageType } from 'src/app/shared/data/response-default.interface';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { ToastService } from 'src/app/shared/services/toast.service';
import { IPartner } from 'src/app/pages/partners/models/partner.interface';
import { IDevice } from 'src/app/pages/devices/models/device.interface';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';
import { SessionService } from 'src/app/shared/services/session.service';
import { FilasService } from '../../services/filas.service';
import { canPickCompany } from 'src/app/shared/utilities/company-scope';

@Component({
  selector: 'app-add-new-fila',
  templateUrl: './add-new-fila.component.html',
  styleUrls: ['./add-new-fila.component.scss']
})
export class AddNewFilaComponent implements OnInit {
  ERoleAdminString = ERoleAdminString;

  @Output() recarregarListagem = new EventEmitter();
  @Input() companyId?: string;
  @Input() partnerId?: string;

  formFila = new UntypedFormGroup({
    name: new UntypedFormControl('', [Validators.required]),
    description: new UntypedFormControl('', [Validators.required]),
    companyId: new UntypedFormControl(null, [Validators.required]),
    onlineSupportEmail: new UntypedFormControl('', [Validators.email]),
    offlineSupportEmail: new UntypedFormControl('', [Validators.email]),
    showPatientData: new UntypedFormControl(false)
  });

  isAdmOlive = false;
  // Usuário de empresa fica fixo na própria (sem seletor); interno e parceiro sem empresa escolhem.
  podeEscolherEmpresa = false;
  private empresaFixa?: string;

  opcoesCompany: ICompany[] = [];
  opcoesPartner: IPartner[] = [];
  devices: IDevice[] = [];
  dadosPaginacao = {
    ordenacao: EOrdenacao.AlfabeticaAZ,
    paginaSelecionada: 0,
    tamanhoPagina: 10,
    totalPaginas: 0,
    itensTotal: 0
  };

  formAberto = false;
  companyControl = new UntypedFormControl();

  constructor(
    private readonly toastr: ToastService,
    private readonly companyService: CompanyService,
    private readonly sessionService: SessionService,
    private readonly filaService: FilasService
  ) {}

  ngOnInit(): void {
    const session = this.sessionService.getSession();
    this.isAdmOlive = session.role === ERoleAdminString.Admin;
    this.partnerId = session.partnerId;
    this.podeEscolherEmpresa = canPickCompany(session);

    if (!this.podeEscolherEmpresa) {
      this.empresaFixa = session.companyId;
      this.formFila.get('companyId')?.setValue(this.empresaFixa ?? null);
      return;
    }

    // Company/ListActive já vem escopado pelo token: tudo para o interno, só as do parceiro para o parceiro.
    this.companyService.listarEmpresasAtivas().subscribe((response) => {
      this.opcoesCompany = response.data;
    });
  }

  changeAccountRole(): void {
    if (this.isAdmOlive) {
      const accountRoleValue = this.formFila.get('accountRole')?.value;
      if (accountRoleValue === 0) {
        this.formFila.get('partnerId')?.patchValue(null);
        this.formFila.get('partnerId')?.disable();

        this.formFila.get('companyId')?.patchValue(null);
        this.formFila.get('companyId')?.disable();
      } else {
        this.formFila.get('partnerId')?.enable();
        this.formFila.get('companyId')?.enable();
        this.formFila.get('partnerId')?.setValidators([Validators.required]);
      }
    }
  }

  changePartner(): void {
    const partnerValue = this.formFila.get('partnerId')?.value;

    if (partnerValue) {
      this.companyService.listarEmpresasAtivas();
    }
  }

  salvarFila(): void {
    if (this.formFila.invalid) {
      this.toastr.toast('Existem campos obrigatórios que não foram preenchidos.', EMessageType.Error);
      this.formFila.markAllAsTouched();
      return;
    }

    const fila = this.formFila.getRawValue();

    this.filaService.adicionarFila(fila).subscribe((res) => {
      if (res.messages && res.messages.length) {
        this.toastr.toast(res.messages);
      }

      if (res.isSucceed) {
        // reset() limparia a empresa fixa, deixando o campo obrigatório escondido vazio.
        this.formFila.reset({ companyId: this.empresaFixa ?? null });
        this.recarregarListagem.emit();
      }
    });
  }
}
